/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'
import { registeredTaxIDDataVerificationSchema } from './RegisteredTaxIDDataVerificationSchema'

export const registeredTaxIDDataSchema = z.object({
	id: z.string(),
	value: z.string(),
	verification: registeredTaxIDDataVerificationSchema,
})

export type RegisteredTaxIDDataSchema = z.infer<typeof registeredTaxIDDataSchema>
